module.exports = __webpack_public_path__ + "img/TIX.798c6316.svg";